import { getCampaign, checkCampaignValidity, activateWorkflow, continueWorkflow } from "../../../api/campaign";
import { getUnixTimeMinuteGranularity } from "../../../utils";
import { getCurrentProcess } from "../../../utils";
import { startPolling } from "../helpers/poller";
import { defaultHandlerBuilder } from "../helpers/defaultPolling";
import CampaignUser from "./campaignUser";
import { type Campaign } from "../../../../types/campaign";
export enum CampaignStatus {
  RUNNING = "running",
  OVER = "over",
  TEASING = "teasing"
}

const checkValidity = async (campaignKey: string, now: number) => {
  try {
    await checkCampaignValidity(campaignKey, now);
    return true;
  } catch (error) {
    return false;
  }
};

export function isTeasing(campaign: Campaign): boolean {
  return !campaign.is_running && !campaign.has_ended && campaign.period_not_yet_started;
}

export function isCampaignOver(campaign: Campaign, isValid: boolean): boolean {
  return (
    !isValid ||
    campaign.is_valid === false ||
    campaign.period_has_ended ||
    campaign.has_ended ||
    !campaign.is_running
  );
}

export const checkStatus = (campaign: Campaign, isValid = true) => {
  if (isTeasing(campaign)) {
    return CampaignStatus.TEASING;
  } else if (isCampaignOver(campaign, isValid)) {
    return CampaignStatus.OVER;
  } else if (campaign.is_running) {
    return CampaignStatus.RUNNING;
  }
};

const CampaignHelper = {
  getStatus: async (campaignKey: string) => {
    const now = getUnixTimeMinuteGranularity();
    const [{ result: campaign }, isValid] = await Promise.all([
      getCampaign(campaignKey, now),
      checkValidity(campaignKey, now)
    ]);

    return checkStatus(campaign, isValid);
  },
  enter: async (addressId: number) => {
    await activateWorkflow(addressId);
    const campaignUser = await CampaignUser.get();
    const lastUserStatusUpdate = campaignUser.current_status_updated_at;
    const processKey = getCurrentProcess(campaignUser.metadata);
    await continueWorkflow(processKey);

    return startPolling(defaultHandlerBuilder, lastUserStatusUpdate);
  }
};

export default CampaignHelper;
